function toggleFavorite(button, event) {
    event.stopPropagation();
    event.preventDefault();

    const certNum = button.dataset.cert_num;
    const svgElement = button.querySelector('svg');

    if (!certNum || !svgElement) return; // Gerekli elemanlar yoksa işlem yapma

    // 'favorited' class'ını toggle et (varsa kaldır, yoksa ekle)
    svgElement.classList.toggle('favorited');

    const index = favDiamondsCertNums.indexOf(certNum);

    if (index > -1) {
        // Zaten favorilerde, listeden çıkar
        favDiamondsCertNums.splice(index, 1);
    } else {
        // Favorilerde değil, listeye ekle
        favDiamondsCertNums.push(certNum);
    }

    // Değişikliği cookie'ye kaydet
    saveFavoritesToCookie();
}

function togglePopupFavorite(button, event) {
    event.stopPropagation();
    event.preventDefault();

    const certNum = button.dataset.cert_num;
    const svgElement = button.querySelector('svg');

    // Gerekli elemanlar (certNum veya svg ikonu) yoksa işlemi durdur
    if (!certNum || !svgElement) {
        console.error("Sertifika numarası (data-cert_num) veya SVG elementi bulunamadı.");
        return;
    }

    // SVG ikonunun favori durumunu değiştir (görsel olarak)
    svgElement.classList.toggle('favorited');

    const index = favDiamondsCertNums.indexOf(certNum);

    // Butonun metnini tutan text node'u bulalım (SVG'yi silmemek için)
    const textNode = button.firstChild;

    if (index > -1) {
        // Zaten favorilerde, listeden çıkar
        favDiamondsCertNums.splice(index, 1);
        // Buton metnini güncelle
        if (textNode.nodeType === Node.TEXT_NODE) {
            textNode.nodeValue = 'Favorilere Ekle ';
        }
    } else {
        // Favorilerde değil, listeye ekle
        favDiamondsCertNums.push(certNum);
        // Buton metnini güncelle
        if (textNode.nodeType === Node.TEXT_NODE) {
            textNode.nodeValue = 'Favorilerden Çıkar ';
        }
    }

    // Değişikliği cookie'ye kaydet
    saveFavoritesToCookie();
}

function saveFavoritesToCookie() {
    // Cookie'yi 1 yıl geçerli olacak şekilde ayarla
    const date = new Date();
    date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
    const expires = "; expires=" + date.toUTCString();
    document.cookie = "favDiamonds=" + JSON.stringify(favDiamondsCertNums) + expires + "; path=/";
}

/**
 * Cookie'den favori pırlanta listesini yükler.
 * @returns {string[]} Favori sertifika numaralarının dizisi.
 */
function loadFavoritesFromCookie() {
    const name = "favDiamonds=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            try {
                const cookieValue = c.substring(name.length, c.length);
                // Boş string ise boş array dön
                return cookieValue ? JSON.parse(cookieValue) : [];
            } catch (e) {
                console.error("Error parsing favDiamonds cookie:", e);
                return [];
            }
        }
    }
    return [];
}

/**
 * Pırlanta listesi render edildikten sonra favori ikonlarının durumunu günceller.
 */
function updateFavoriteIcons() {
    const allFavButtons = document.querySelectorAll('.fav-diamond-button');
    allFavButtons.forEach(button => {
        const certNum = button.dataset.cert_num;
        const svgElement = button.querySelector('svg');
        if (svgElement && favDiamondsCertNums.includes(certNum)) {
            svgElement.classList.add('favorited');
        } else if (svgElement) {
            svgElement.classList.remove('favorited');
        }
    });
}

document.addEventListener('click', function(e) {
    // Tıklanan elementin veya üst elementlerinden birinin '.fav-diamond-button' olup olmadığını kontrol et
    const favButton = e.target.closest('.fav-diamond-button');

    if (favButton) {
        // ÖNEMLİ: Olayın üst elementlere (<tr> gibi) yayılmasını engelle
        e.stopPropagation();
        e.preventDefault(); // Olası link davranışlarını engelle

        const certNum = favButton.dataset.cert_num;
        const svgElement = favButton.querySelector('svg');

        if (!certNum || !svgElement) return; // Gerekli elemanlar yoksa işlem yapma

        // 'favorited' class'ını toggle et (varsa kaldır, yoksa ekle)
        svgElement.classList.toggle('favorited');

        const index = favDiamondsCertNums.indexOf(certNum);

        if (index > -1) {
            // Zaten favorilerde, listeden çıkar
            favDiamondsCertNums.splice(index, 1);
        } else {
            // Favorilerde değil, listeye ekle
            favDiamondsCertNums.push(certNum);
        }

        // Değişikliği cookie'ye kaydet
        saveFavoritesToCookie();
    }
});

function updateGallery(videoUrl) {
    const videoThumbnail = document.querySelector('.thumbnail[data-target="video"]');
    const imageThumbnail = document.querySelector('.thumbnail[data-target="image"]');
    const imageThumbnail2 = document.querySelector('.thumbnail[data-target="image2"]');
    
    const videoView = document.querySelector('[data-gallery-item="video"]');
    const imageView = document.querySelector('[data-gallery-item="image"]');
    const imageView2 = document.querySelector('[data-gallery-item="image2"]');

    
    const allThumbnails = document.querySelectorAll('.thumbnail');

    // Önceki seçimleri temizle
    allThumbnails.forEach(thumb => thumb.classList.remove('active'));

    // Video URL'si var mı ve geçerli mi diye kontrol et
    if (videoUrl && videoUrl !== 'null' && videoUrl !== 'undefined' && videoUrl !== '-' && videoUrl.trim() !== '') {
        // --- VİDEO VARSA ---
        videoThumbnail.style.display = 'inline-block'; // Video küçük resmini göster
        videoThumbnail.classList.add('active');        // Aktif olarak işaretle
        
        videoView.style.display = 'block';             // Ana görünümde videoyu göster
        imageView.style.display = 'none';
        imageView2.style.display = 'none';

    } else {
        // --- VİDEO YOKSA ---
        videoThumbnail.style.display = 'none';         // Video küçük resmini gizle
        imageThumbnail.classList.add('active');        // Resim küçük resmini aktif yap

        imageView.style.display = 'block';             // Ana görünümde resmi göster
        videoView.style.display = 'none';
        imageView2.style.display = 'none';
    }
}

// A helper function to neatly create and append the final iframe
function renderIframeInContainer(container, directVideoUrl) {
    container.innerHTML = ''; // Clear any previous content (like loading text)
    const iframe = document.createElement('iframe');
    
    iframe.className = 'dx-rapgab-fdpv-video';
    iframe.src = directVideoUrl;
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allow', 'fullscreen; autoplay; xr-spatial-tracking');
    iframe.allowFullscreen = true;
    iframe.style.width = '100%';
    iframe.style.maxWidth = '100%';
    iframe.style.height = '100%';

    container.appendChild(iframe);
}

function showLoader(containerElement) {
  if (getComputedStyle(containerElement).position === 'static') {
    containerElement.style.position = 'relative';
  }

  // --- SVG MASKELEME YÖNTEMİYLE GÜNCELLENMİŞ SVG KODU ---
  const logoSVG = `
    <svg xmlns="http://www.w3.org/2000/svg" id="Layer_2" class="loader-logo" viewBox="0 0 596.32 76.79">
      <defs>
        <mask id="logo-mask">
          <rect id="mask-reveal-rect" x="-100%" y="0" width="100%" height="100%" fill="white" />
        </mask>
      </defs>
      <g id="Layer_1-2" data-name="Layer_1">
        <g fill="#e0e0e0">
          <path d="M61.98,21.64c2.74-2.28,5.48-4.56,8.22-6.84-2.38-2.83-8.24-8.99-18.1-12.32-4.06-1.37-14.09-4.05-25.6-.31C9.14,7.82,2.84,23.37,2.23,24.96c-.44,1.14-7.05,19.29,4.85,35.52,9.93,13.54,25.27,15.56,27.82,15.85,4.31.5,13.8.89,23.67-4.42,3.27-1.76,11.09-6.57,15.95-16.26,4.63-9.25,3.96-17.73,3.51-21.02-12.83.07-25.66.14-38.49.2.02,3.13.05,6.26.07,9.39,8.48-.05,16.95-.09,25.43-.14-.28,2.57-1.41,9.49-7.23,15.1-7.18,6.92-17.85,8.35-26.27,5.72-7.56-2.37-11.7-7.51-13.07-9.25-6.87-8.78-5.79-18.61-5.48-21.09.36-2.88,1.25-9.18,6.39-14.83,7.18-7.89,17.15-8.5,19.32-8.57,13.68-.48,22.25,9.26,23.29,10.49Z"/>
          <path d="M124.38,1.76c-2.56-.03-5.13-.07-7.69-.1-11.77,24.59-23.54,49.18-35.3,73.77,4.42-.02,8.85-.06,13.28-.09l6.43-15.1c12.57-.07,25.14-.14,37.72-.21,2.14,5.11,4.28,10.21,6.41,15.31h14.05c-11.63-24.53-23.26-49.06-34.9-73.58ZM105.64,50.8c4.9-10.28,9.81-20.56,14.71-30.84,4.79,10.3,9.58,20.6,14.36,30.9-9.69-.02-19.38-.04-29.07-.06Z"/>
          <path d="M224.47,42.18c-3.04-3.37-6.57-4.92-8.54-5.62,1.27-.59,6.5-3.17,8.96-9.18,2.66-6.51.12-12.26-.53-13.68-2.35-5.09-6.44-7.59-8.12-8.57-4.06-2.4-7.96-2.93-10.01-3.06-11.37-.04-22.74-.07-34.11-.1v73.47h33.52c2.58-.17,7.05-.79,11.75-3.35,3.01-1.64,9.99-5.43,11.8-13.37,2.01-8.82-3.99-15.7-4.74-16.53ZM204.85,11.45c.49.14,7.22,2.15,8.83,8.14.66,2.44.21,4.58-.16,5.79-.28.97-.93,2.69-2.47,4.34-2.18,2.33-4.8,3.04-5.83,3.27-6.87.02-13.74.04-20.61.05-.02-7.18-.03-14.35-.04-21.53,6.76-.02,13.52-.04,20.28-.06ZM216.65,57.04c-.31,1.08-1.03,3-2.73,4.82-2.41,2.58-5.32,3.38-6.46,3.63-7.62.02-15.23.04-22.84.06-.01-7.97-.03-15.95-.04-23.92,7.49-.02,14.98-.04,22.48-.06.55.15,7.99,2.39,9.78,9.04.73,2.71.23,5.09-.18,6.43Z"/>
          <path d="M287.55,44.22c1.83-.45,9.92-2.66,13.91-9.93,2.41-4.4,2.4-8.94,2.39-11.02,0-1.99-.02-4.84-1.41-8.16-2.31-5.55-6.77-8.41-8.57-9.53-4.52-2.81-8.95-3.44-11.34-3.61-12.19-.07-24.38-.14-36.56-.2.07,24.56.14,49.12.21,73.67,3.85.07,7.69.15,11.54.22.02-10.07.04-20.14.05-30.21h17.39c5.22,9.99,10.43,19.99,15.65,29.98h13.97c-5.74-10.4-11.48-20.81-17.22-31.21ZM281.15,36.66c-7.66.02-15.32.04-22.98.06-.01-8.17-.03-16.33-.04-24.5,7.53-.02,15.08-.04,22.62-.06.54.16,8.04,2.46,9.85,9.26.74,2.77.23,5.21-.19,6.59-.31,1.1-1.03,3.07-2.74,4.94-2.43,2.65-5.36,3.46-6.5,3.72Z"/>
          <path d="M320.88,75.43c-.04-15.84-.07-31.68-.11-47.52,4.25-3.24,8.5-6.48,12.75-9.72-.03,19.12-.05,38.24-.08,57.36l-12.56-.12Z"/>
          <path d="M320.95,17.58c-.06-5.36-.12-10.72-.18-16.07,4.21.03,8.43.07,12.64.1v6.89c-4.16,3.03-8.31,6.06-12.47,9.08Z"/>
          <path d="M387.9,1.61h-7.01c-11.86,24.61-23.73,49.22-35.59,73.82h12.78c2.37-5.19,4.74-10.38,7.12-15.57,12.42.01,24.85.02,37.27.02,2.32,5.19,4.64,10.37,6.96,15.55h13.85c-11.79-24.61-23.58-49.22-35.37-73.82ZM369.62,50.8c4.9-10.28,9.81-20.56,14.71-30.84,4.79,10.3,9.58,20.6,14.36,30.9-9.69-.02-19.38-.04-29.07-.06Z"/>
          <path d="M434.94,75.43c-.05-24.62-.11-49.25-.16-73.87,2.39.05,4.78.09,7.16.14,15,17.28,29.99,34.56,44.99,51.84-.05-17.31-.11-34.62-.16-51.92,4.23.03,8.46.07,12.7.1.01,24.57.03,49.15.04,73.72h-8.26c-14.61-17-29.22-34.01-43.83-51.01-.13,17-.26,34.01-.4,51.01h-12.09Z"/>
          <path d="M555.52,0c-22.54,0-40.81,17.19-40.81,38.39s18.27,38.39,40.81,38.39,40.8-17.19,40.8-38.39S578.05,0,555.52,0ZM555.9,65.54c-15.65,0-28.34-12.1-28.34-27.02s12.69-27.03,28.34-27.03,28.34,12.1,28.34,27.03-12.69,27.02-28.34,27.02Z"/>
        </g>

        <g fill="#463834" mask="url(#logo-mask)">
          <path d="M61.98,21.64c2.74-2.28,5.48-4.56,8.22-6.84-2.38-2.83-8.24-8.99-18.1-12.32-4.06-1.37-14.09-4.05-25.6-.31C9.14,7.82,2.84,23.37,2.23,24.96c-.44,1.14-7.05,19.29,4.85,35.52,9.93,13.54,25.27,15.56,27.82,15.85,4.31.5,13.8.89,23.67-4.42,3.27-1.76,11.09-6.57,15.95-16.26,4.63-9.25,3.96-17.73,3.51-21.02-12.83.07-25.66.14-38.49.2.02,3.13.05,6.26.07,9.39,8.48-.05,16.95-.09,25.43-.14-.28,2.57-1.41,9.49-7.23,15.1-7.18,6.92-17.85,8.35-26.27,5.72-7.56-2.37-11.7-7.51-13.07-9.25-6.87-8.78-5.79-18.61-5.48-21.09.36-2.88,1.25-9.18,6.39-14.83,7.18-7.89,17.15-8.5,19.32-8.57,13.68-.48,22.25,9.26,23.29,10.49Z"/>
          <path d="M124.38,1.76c-2.56-.03-5.13-.07-7.69-.1-11.77,24.59-23.54,49.18-35.3,73.77,4.42-.02,8.85-.06,13.28-.09l6.43-15.1c12.57-.07,25.14-.14,37.72-.21,2.14,5.11,4.28,10.21,6.41,15.31h14.05c-11.63-24.53-23.26-49.06-34.9-73.58ZM105.64,50.8c4.9-10.28,9.81-20.56,14.71-30.84,4.79,10.3,9.58,20.6,14.36,30.9-9.69-.02-19.38-.04-29.07-.06Z"/>
          <path d="M224.47,42.18c-3.04-3.37-6.57-4.92-8.54-5.62,1.27-.59,6.5-3.17,8.96-9.18,2.66-6.51.12-12.26-.53-13.68-2.35-5.09-6.44-7.59-8.12-8.57-4.06-2.4-7.96-2.93-10.01-3.06-11.37-.04-22.74-.07-34.11-.1v73.47h33.52c2.58-.17,7.05-.79,11.75-3.35,3.01-1.64,9.99-5.43,11.8-13.37,2.01-8.82-3.99-15.7-4.74-16.53ZM204.85,11.45c.49.14,7.22,2.15,8.83,8.14.66,2.44.21,4.58-.16,5.79-.28.97-.93,2.69-2.47,4.34-2.18,2.33-4.8,3.04-5.83,3.27-6.87.02-13.74.04-20.61.05-.02-7.18-.03-14.35-.04-21.53,6.76-.02,13.52-.04,20.28-.06ZM216.65,57.04c-.31,1.08-1.03,3-2.73,4.82-2.41,2.58-5.32,3.38-6.46,3.63-7.62.02-15.23.04-22.84.06-.01-7.97-.03-15.95-.04-23.92,7.49-.02,14.98-.04,22.48-.06.55.15,7.99,2.39,9.78,9.04.73,2.71.23,5.09-.18,6.43Z"/>
          <path d="M287.55,44.22c1.83-.45,9.92-2.66,13.91-9.93,2.41-4.4,2.4-8.94,2.39-11.02,0-1.99-.02-4.84-1.41-8.16-2.31-5.55-6.77-8.41-8.57-9.53-4.52-2.81-8.95-3.44-11.34-3.61-12.19-.07-24.38-.14-36.56-.2.07,24.56.14,49.12.21,73.67,3.85.07,7.69.15,11.54.22.02-10.07.04-20.14.05-30.21h17.39c5.22,9.99,10.43,19.99,15.65,29.98h13.97c-5.74-10.4-11.48-20.81-17.22-31.21ZM281.15,36.66c-7.66.02-15.32.04-22.98.06-.01-8.17-.03-16.33-.04-24.5,7.53-.02,15.08-.04,22.62-.06.54.16,8.04,2.46,9.85,9.26.74,2.77.23,5.21-.19,6.59-.31,1.1-1.03,3.07-2.74,4.94-2.43,2.65-5.36,3.46-6.5,3.72Z"/>
          <path d="M320.88,75.43c-.04-15.84-.07-31.68-.11-47.52,4.25-3.24,8.5-6.48,12.75-9.72-.03,19.12-.05,38.24-.08,57.36l-12.56-.12Z"/>
          <path d="M320.95,17.58c-.06-5.36-.12-10.72-.18-16.07,4.21.03,8.43.07,12.64.1v6.89c-4.16,3.03-8.31,6.06-12.47,9.08Z"/>
          <path d="M387.9,1.61h-7.01c-11.86,24.61-23.73,49.22-35.59,73.82h12.78c2.37-5.19,4.74-10.38,7.12-15.57,12.42.01,24.85.02,37.27.02,2.32,5.19,4.64,10.37,6.96,15.55h13.85c-11.79-24.61-23.58-49.22-35.37-73.82ZM369.62,50.8c4.9-10.28,9.81-20.56,14.71-30.84,4.79,10.3,9.58,20.6,14.36,30.9-9.69-.02-19.38-.04-29.07-.06Z"/>
          <path d="M434.94,75.43c-.05-24.62-.11-49.25-.16-73.87,2.39.05,4.78.09,7.16.14,15,17.28,29.99,34.56,44.99,51.84-.05-17.31-.11-34.62-.16-51.92,4.23.03,8.46.07,12.7.1.01,24.57.03,49.15.04,73.72h-8.26c-14.61-17-29.22-34.01-43.83-51.01-.13,17-.26,34.01-.4,51.01h-12.09Z"/>
          <path d="M555.52,0c-22.54,0-40.81,17.19-40.81,38.39s18.27,38.39,40.81,38.39,40.8-17.19,40.8-38.39S578.05,0,555.52,0ZM555.9,65.54c-15.65,0-28.34-12.1-28.34-27.02s12.69-27.03,28.34-27.03,28.34,12.1,28.34,27.03-12.69,27.02-28.34,27.02Z"/>
        </g>
      </g>
    </svg>
  `;

  const loaderOverlayHTML = `<div class="logo-loader-overlay">${logoSVG}</div>`;
  containerElement.insertAdjacentHTML('beforeend', loaderOverlayHTML);
}

function hideLoader(containerElement) {
  const loader = containerElement.querySelector('.logo-loader-overlay');
  if (loader) {
    loader.remove();
  }
}

async function displayJspVideo(container, jspUrl) {
  // Önceki içeriği temizle ve kapsayıcıyı görünür yap
  container.style.display = 'block';
  container.innerHTML = '';

  // 1. Yeni yükleyici animasyonunu göster
  showLoader(container);

  try {
    // 2. Kendi backend proxy'nizi çağırın
    const backendUrl = 'https://fair-column-449114-n6.oa.r.appspot.com';
    const proxyUrl = `${backendUrl}/proxy-video?url=${encodeURIComponent(jspUrl)}`;
    const response = await fetch(proxyUrl);

    if (!response.ok) {
      throw new Error(`Proxy failed with status: ${response.status}`);
    }

    const htmlText = await response.text();

    // 3. Gelen HTML'i ayrıştırıp içindeki iframe'in URL'sini bulun
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlText, 'text/html');
    const innerIframe = doc.querySelector('div.videowrapper iframe');

    if (!innerIframe || !innerIframe.src) {
      throw new Error('İç video iframe\'i yanıtta bulunamadı.');
    }

    const directVideoUrl = innerIframe.src;
    
    // 4. Son iframe'i render et (bu fonksiyonu bir önceki cevaptan alıyoruz)
    renderIframeInContainer(container, directVideoUrl);

  } catch (error) {
    console.error('JSP videosu gösterilemedi:', error);
    container.innerHTML = 'Hata: Video yüklenemedi.';
  } finally {
    // 5. ÖNEMLİ: İşlem başarılı da olsa, başarısız da olsa yükleyiciyi her zaman gizle
    hideLoader(container);
  }
}

 function createViewProductDiamond(button) {
    const measWidth = button.getAttribute('data-meas_width');
    const measLength = button.getAttribute('data-meas_length');
    const measDepth = button.getAttribute('data-meas_depth');
    const measshape = button.getAttribute('data-shape');
    const meassize = button.getAttribute('data-size');
    const meascolor = button.getAttribute('data-color');
    const measclarity = button.getAttribute('data-clarity');
    const meascut = button.getAttribute('data-cut');
    const measpolish = button.getAttribute('data-polish');
    const meassymmetry = button.getAttribute('data-symmetry');
    const measfluorIntensity = button.getAttribute('data-fluor_intensity');
    const measlab = button.getAttribute('data-lab');
    const meascertNum = button.getAttribute('data-cert_num');
    const measprice = button.getAttribute('data-price');
    const measvideo = button.getAttribute('data-video_url');
    const measCertificateUrl = button.getAttribute('data-certificate_url');
    const popupCartButton = document.querySelector('#popupCartButton');
    const popupProductAddButton = document.querySelector('#popupProductAddButton');
    const popupFavButton = document.querySelector('#popupFavButton');
    popupCartButton.setAttribute('data-meas_width', measWidth);
    popupCartButton.setAttribute('data-meas_length', measLength);
    popupCartButton.setAttribute('data-meas_depth', measDepth);
    popupCartButton.setAttribute('data-shape', measshape);
    popupCartButton.setAttribute('data-size', meassize);
    popupCartButton.setAttribute('data-color', meascolor);
    popupCartButton.setAttribute('data-clarity', measclarity);
    popupCartButton.setAttribute('data-cut', meascut);
    popupCartButton.setAttribute('data-polish', measpolish);
    popupCartButton.setAttribute('data-symmetry', meassymmetry);
    popupCartButton.setAttribute('data-fluor_intensity', measfluorIntensity);
    popupCartButton.setAttribute('data-lab', measlab);
    popupCartButton.setAttribute('data-cert_num', meascertNum);
    popupCartButton.setAttribute('data-price', measprice);
    popupCartButton.setAttribute('data-video_url', measvideo);
    popupProductAddButton.setAttribute('data-meas_width', measWidth);
    popupProductAddButton.setAttribute('data-meas_length', measLength);
    popupProductAddButton.setAttribute('data-meas_depth', measDepth);
    popupProductAddButton.setAttribute('data-shape', measshape);
    popupProductAddButton.setAttribute('data-size', meassize);
    popupProductAddButton.setAttribute('data-color', meascolor);
    popupProductAddButton.setAttribute('data-clarity', measclarity);
    popupProductAddButton.setAttribute('data-cut', meascut);
    popupProductAddButton.setAttribute('data-polish', measpolish);
    popupProductAddButton.setAttribute('data-symmetry', meassymmetry);
    popupProductAddButton.setAttribute('data-fluor_intensity', measfluorIntensity);
    popupProductAddButton.setAttribute('data-lab', measlab);
    popupProductAddButton.setAttribute('data-cert_num', meascertNum);
    popupProductAddButton.setAttribute('data-price', measprice);
    popupProductAddButton.setAttribute('data-video_url', measvideo);
    popupFavButton.setAttribute('data-cert_num', meascertNum);
    const favButtonSvg = popupFavButton.querySelector('svg');
    const favButtonTextNode = popupFavButton.firstChild;

    if (favDiamondsCertNums.includes(meascertNum)) {
        favButtonSvg.classList.add('favorited');
        if (favButtonTextNode.nodeType === Node.TEXT_NODE) {
            favButtonTextNode.nodeValue = 'Favorilerden Çıkar ';
        }
    } else {
        favButtonSvg.classList.remove('favorited');
        if (favButtonTextNode.nodeType === Node.TEXT_NODE) {
            favButtonTextNode.nodeValue = 'Favorilere Ekle ';
        }
    }

    document.querySelector('.dx-diamond-width span').textContent = measWidth + ' mm';
    document.querySelector('.dx-diamond-lenght span').textContent = measLength + ' mm';
    document.querySelector('.dx-diamond-depth span').textContent = measDepth + ' mm';
    const container = document.querySelector('.dx-rapgab-fdpv-video-container');
    updateGallery(measvideo);
    const videoThumbnail = document.querySelector('.thumbnail[data-target="video"]');
    const imageThumbnail = document.querySelector('.thumbnail[data-target="image"]');
    const logoThumbnail = document.querySelector('[data-cert-image="logo"]');
    const logoThumbnailLink = document.querySelector('.thumbnail[data-cert-link="logo"]');

    if (!measvideo || measvideo === "null" || measvideo === "-") {
    container.style.display = 'none';
    container.innerHTML = ''; 
    } else {
        if (measvideo.includes('appVideo.jsp')) {
            displayJspVideo(container, measvideo);
        } else {
            showLoader(container);
            container.style.display = 'block';
            const isEmbeddablePage = /\.html?($|[?#])/i.test(measvideo);
            
            let el = container.querySelector('.dx-rapgab-fdpv-video');

            if (!el || (isEmbeddablePage && el.tagName !== 'IFRAME') || (!isEmbeddablePage && el.tagName !== 'VIDEO')) {
                container.innerHTML = '';
                el = document.createElement(isEmbeddablePage ? 'iframe' : 'video');
                el.className = 'dx-rapgab-fdpv-video';
                
                if (isEmbeddablePage) {
                    el.setAttribute('frameborder', '0');
                    el.setAttribute('allow', 'fullscreen; autoplay; xr-spatial-tracking');
                    el.allowFullscreen = true;
                    el.style.width = '100%';
                    el.style.maxWidth = '100%';
                    el.style.height = '100%';
                } else {
                    el.controls = false;
                    el.loop = true;
                    el.autoplay = true;
                    el.style.width = '100%';
                }
                hideLoader(container);
                container.appendChild(el);
            }
            hideLoader(container);
            el.src = measvideo;
        }
    }

    document.querySelector('.dx-rapgab-fdpv-il-shape span').textContent = measshape;
    document.querySelector('.dx-rapgab-fdpv-il-carat span').textContent = meassize;
    document.querySelector('.dx-rapgab-fdpv-il-renk span').textContent = meascolor;
    document.querySelector('.dx-rapgab-fdpv-il-berraklik span').textContent = measclarity;
    document.querySelector('.dx-rapgab-fdpv-il-kesim span').textContent = meascut;
    document.querySelector('.dx-rapgab-fdpv-il-cila span').textContent = measpolish;
    document.querySelector('.dx-rapgab-fdpv-il-simetri span').textContent = meassymmetry;
    document.querySelector('.dx-rapgab-fdpv-il-florasan span').textContent = measfluorIntensity;
    document.querySelector('.dx-rapgab-fdpv-il-cert span').textContent = meascertNum;
    document.querySelector('.dx-rapgab-fdpv-il-price span').textContent = new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(measprice * dxCurrency);

    let reportUrl;
    let imageUrl;

    // Önce logoyu laboratuvara göre belirle
    switch (measlab) {
        case 'GIA':
            imageUrl = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/gia_pop_up_logo.png?v=1759142502';
            imageUrlLogo = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/GIA-certified-logo.png?v=1758735644';
            break;
        case 'HRD':
            imageUrl = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/hrd-antwerp-logo-vector.png?v=1702482411';
            imageUrlLogo = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/hrd-antwerp-profile.jpg?v=1758735742';
            break;
        case 'IGI':
            imageUrl = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/igi_pop_up_logo.png?v=1759142502';
            imageUrlLogo = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/IGI.jpg?v=1758736294';
            break;
        default:
            imageUrl = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/gia_pop_up_logo.png?v=1759142502';
            imageUrlLogo = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/GIA-certified-logo.png?v=1758735644';
    }

    // Sonra linki belirle. Öncelik her zaman direkt PDF linkinde.
    if (measCertificateUrl && measCertificateUrl !== 'null' && measCertificateUrl !== 'undefined' && measCertificateUrl.trim() !== '') {
        reportUrl = measCertificateUrl;
    } else {
        switch (measlab) {
            case 'HRD':
                reportUrl = 'https://my.hrdantwerp.com';
                break;
            case 'IGI':
                 reportUrl = 'https://www.igi.org/reports/verify-your-report?r=' + meascertNum;
                 break;
            case 'GIA':
            default:
                reportUrl = 'https://www.gia.edu/report-check?reportno=' + meascertNum;
                break;
        }
    }

    // Belirlenen URL ve logoyu hem mobil hem de masaüstü butonlarına ata
    document.querySelector('.dx-rapgab-fdpv-cer-button a').setAttribute('href', reportUrl);
    document.querySelector('.dx-rapgab-fdpv-cer-button img').setAttribute('src', imageUrl);
    logoThumbnail.setAttribute('src', imageUrlLogo);
    logoThumbnailLink.setAttribute('href', reportUrl);
    
    // Kaydırma pozisyonunu kaydet
    previousScrollPosition = document.documentElement.scrollTop;
    previousScrollPopupPosition = document.querySelector('.dx-diamond-popup-content-container').scrollTop;

    // Yeni div'i görüntüleyin ve o div'e kaydırın
    var detailedProductView = document.querySelector('.dx-rapgab-filter-detailed-product-view');
    var totalheightDetect = document.querySelector('.dx-rapgab-slider-container');
    document.querySelector('.scrollable-table').scrollLeft = 0;
    document.querySelector('.scrollable-table').style.display = 'none';
    detailedProductView.style.display = 'flex';

    // dxRapgabfdpvImage id'li img elementinin src'sini güncelle
    var shapeImageUrl;
    var shapeImageUrl2;
    switch (measshape) {
        case "Yuvarlak":
            shapeImageUrl = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/yuvarlak_v2.png?v=1760622745';
            shapeImageUrl2 = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/yuvarlak_2.png?v=1760604978';
            break;
        case "Oval":
            shapeImageUrl = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/oval_v2.png?v=1760622745';
            shapeImageUrl2 = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/oval_2.png?v=1760604978';
            break
        case "Kalp":
            shapeImageUrl = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/kalp_v2.png?v=1760622745';
            shapeImageUrl2 = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/kalp_2.png?v=1760604978';
            break;
        case "Damla":
            shapeImageUrl = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/damla_v2.png?v=1760622745';
            shapeImageUrl2 = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/damla_2.png?v=1760604978';
            break;
        case "Radiant":
            shapeImageUrl = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/radiant_v2.png?v=1760622745';
            shapeImageUrl2 = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/radiant_2.png?v=1760604978';
            break;
        case "Emerald":
            shapeImageUrl = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/emerald_v2.png?v=1760622745';
            shapeImageUrl2 = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/emerald_2.png?v=1760604978';
            break;
        case "Markiz":
            shapeImageUrl = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/markiz_v2.png?v=1760622745';
            shapeImageUrl2 = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/markiz_2.png?v=1760604978';
            break;
        case "Cushion":
            shapeImageUrl = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/cushion_v2.png?v=1760622745';
            shapeImageUrl2 = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/cushion_2.png?v=1760604978';
            break;
        case "Prenses":
            shapeImageUrl = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/prenses_v2.png?v=1760622745';
            shapeImageUrl2 = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/prenses_2.png?v=1760604978';
            break;
        default:
            shapeImageUrl = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/yuvarlak_v2.png?v=1760622745';
            shapeImageUrl2 = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/yuvarlak_2.png?v=1760604978';
    }
    document.getElementById('dxRapgabfdpvImage').setAttribute('src', shapeImageUrl);
    document.getElementById('shapeThumbnail1').setAttribute('src', shapeImageUrl);
    document.getElementById('dxRapgabfdpvImage2').setAttribute('src', shapeImageUrl2);
    document.getElementById('shapeThumbnail2').setAttribute('src', shapeImageUrl2);

    detailedProductViewPosition = document.querySelector('.dx-diamond-show-startpoint').scrollIntoView({ behavior: 'smooth' });
}

function adaptLabDiamondData(labDiamond) {
        // Şekil adlarını kısaltmalardan tam adlara çevirmek için bir harita
        const shapeMap = {
            'EM': 'Emerald',
            'RB': 'Round',
            'OV': 'Oval',
            'PR': 'Princess',
            'CU': 'Cushion',
            'CUSQ': 'Cushion',
            'PE': 'Pear',
            'HT': 'Heart',
            'MQ': 'Marquise',
            'RAD': 'Radiant',
            'ASH': 'Asscher'
        };

        return {
            // Yeni alan adlarını eskisine çevir
            total_sales_price: labDiamond.totalAmount,
            size: labDiamond.carats,
            cert_num: labDiamond.reportNo,
            depth_percent: labDiamond.totalDepthPercent,
            table_percent: labDiamond.tablePercent,
            meas_length: labDiamond.measurementMax,
            meas_width: labDiamond.measurementMin,
            meas_depth: labDiamond.measurementHeight,
            fluor_intensity: labDiamond.fluorescence,
            shape: shapeMap[labDiamond.shape] || labDiamond.shape, // Kısaltmayı tam isme çevir

            // İsimleri aynı olan alanları doğrudan ata
            color: labDiamond.color,
            clarity: labDiamond.clarity,
            cut: labDiamond.cut,
            polish: labDiamond.polish,
            symmetry: labDiamond.symmetry,
            lab: labDiamond.lab,
            
            // Sıralama için kullanılan alanlar
            shapeOrder: labDiamond.shapeOrder,
            colorOrder: labDiamond.colorOrder,
            clarityOrder: labDiamond.clarityOrder,
            cutOrder: labDiamond.cutOrder,
            polishOrder: labDiamond.polishOrder,
            symmetryOrder: labDiamond.symmetryOrder,

            // Mevcut olmayan ama kodun bekleyebileceği alanlar için varsayılan değerler
            video_url: labDiamond.video_url || null,
            image_file_url: labDiamond.image_file_url || null,
            certificate_url: labDiamond.certificateUrl || null
        };
    }

    function updateDiamondMode() {
        const activeButton = document.querySelector('.dx-diamond-lab-or-natural-category.active');
        if (activeButton) {
            isLabDiamondMode = activeButton.getAttribute('data-type') === 'lab';
        }
    }

    function fetchDiamonds(page) {      
         updateDiamondMode();
         var detailedProductView = document.querySelector('.dx-rapgab-filter-detailed-product-view');
        if (detailedProductView) {
            detailedProductView.style.display = 'none';
        }
        document.querySelector('.scrollable-table').style.display = 'block';

        // Pırlanta Şekli için dönüşüm haritası
        const labShapeMap = {
            "Round": "RB",
            "Oval": "OV",
            "Pear": "PE",
            "Radiant": "RAD",
            "Emerald": "EM",
            "Heart": "HT",
            "Marquise": "MQ",
            "Cushion": "CU",
            "Cushion Modified": "CUSQ",
            "Princess": "PR",
            "Asscher": "ASH"
        };

        // Kesim, Parlaklık ve Simetri için ortak dönüşüm haritası
        const labGradeMap = {
            "Excellent": ["EX", "ID"],
            "Very%20Good": ["VG"],
            "Good": ["G"],
            "": [""]
        };

        // Floresan için dönüşüm haritası
        const labFluorescenceMap = {
            "None": "Non",
            "Faint": "Fnt",
            "Medium": "Med",
            "Strong": "Stg",
            "Very%20Strong": "Vst"
        };

        let shapesForApi = chosenShapes;
        let cutsForApi = chosenCuts;
        let symmetryForApi = chosenSymmetry;
        let polishForApi = chosenPolish;
        let fluorescenceForApi = chosenFluorescence;


        if (isLabDiamondMode) {
            shapesForApi = chosenShapes.map(shape => labShapeMap[shape] || shape);
            cutsForApi = chosenCuts.flatMap(cut => labGradeMap[cut] !== undefined ? labGradeMap[cut] : cut);
            symmetryForApi = chosenSymmetry.flatMap(sym => labGradeMap[sym] !== undefined ? labGradeMap[sym] : sym);
            polishForApi = chosenPolish.flatMap(pol => labGradeMap[pol] !== undefined ? labGradeMap[pol] : pol);
            fluorescenceForApi = chosenFluorescence.map(fluo => labFluorescenceMap[fluo] || fluo);
        }

        const apiEndpoint = isLabDiamondMode ? 'https://fair-column-449114-n6.oa.r.appspot.com/lab-diamonds' : 'https://fair-column-449114-n6.oa.r.appspot.com/diamonds';
        let url = `${apiEndpoint}?page=${page}&limit=${mongolimit}&sort=${sortColumn}&order=${sortOrder}`;

        if (minPrice !== null) url += `&minPrice=${minPrice}`;
        if (maxPrice !== null) url += `&maxPrice=${maxPrice}`;
        if (minSize !== null) url += `&minSize=${minSize}`;
        if (maxSize !== null) url += `&maxSize=${maxSize}`;
        if (minColor !== null) url += `&minColor=${minColor}`;
        if (maxColor !== null) url += `&maxColor=${maxColor}`;
        if (chosenLabs.length > 0) url += `&labs=${chosenLabs.join(',')}`;
        if (chosenClarity.length > 0) url += `&clarities=${chosenClarity.join(',')}`;
        
        if (shapesForApi.length > 0) url += `&shapes=${shapesForApi.join(',')}`;
        if (cutsForApi.length > 0) url += `&cuts=${cutsForApi.join(',')}`;
        if (symmetryForApi.length > 0) url += `&symmetries=${symmetryForApi.join(',')}`;
        if (polishForApi.length > 0) url += `&polishes=${polishForApi.join(',')}`;
        if (fluorescenceForApi.length > 0) url += `&fluorescences=${fluorescenceForApi.join(',')}`;

        if (favDiamondsCertNumsFilter && favDiamondsCertNumsFilter.length > 0) {
            url += `&fav_certs=${favDiamondsCertNumsFilter.join(',')}`;
        }

        if (certNum !== null && certNum !== undefined) {
            url = `${apiEndpoint}?page=${page}&limit=${mongolimit}&cert_num=${certNum}`;
        }
        if (excludedIds && excludedIds.length > 0) {
            url += `&excludedIds=${excludedIds.join(',')}`;
        }
        fetch(url)
            .then(response => response.json())
            .then(data => {
                const adaptedData = isLabDiamondMode 
                    ? data.data.map(diamond => adaptLabDiamondData(diamond))
                    : data.data;

                displayPage(page, adaptedData); 
                setupPagination(data.total);
                totalItems = data.total;
                updateFavoriteIcons();
            })
            .catch(error => console.error('Error fetching diamonds:', error));
    }
  function displayPage(page, diamonds) {
        const tableBody = $('#diamondsTable tbody');
        tableBody.empty();
        // ✅ YENİ: API'den gelen kodları okunabilir metinlere çevirmek için bir harita oluşturuyoruz.
        const gradeDisplayMap = {
            'ID': 'Ideal',
            'EX': 'Excellent',
            'VG': 'Very Good',
            'G': 'Good',
            'F': 'Fair',
            'P': 'Poor',
            'Non': 'None',
            'Stg': 'Strong',
            'Fnt': 'Faint',
            'Med': 'Medium',
            '': '-'
        };
        // Eğer diamonds dizisi boş ise, kullanıcıya bir mesaj göster
        if (diamonds.length < 1) {
            tableBody.append("<tr><td colspan='11' class='dx-nodiamond-error'>Aradığınız Kriterlerde Görüntülenecek Taş Bulunamadı! Kriterleri değiştirip tekrardan deneyiniz.</td></tr>");
            return; // Daha fazla işlem yapmamak için fonksiyonu burada sonlandır
        }
    
        diamonds.forEach(diamond => {
            const shapeDisplay = diamond.shape === 'Cushion Modified' ? 'Cushion' : diamond.shape;
            let shapeImageUrl;
            if (shapeDisplay === undefined) {
              return;
            }
             switch (shapeDisplay) {
                case 'Round':
                    shapeDisplayName = "Yuvarlak";
                    shapeImageUrl = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/Yuvarlak_vSon.png?v=1723103033';
                    break;
                case 'Oval':
                    shapeDisplayName = "Oval";
                    shapeImageUrl = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/Oval_vSon.png?v=1723103033';
                    break;
                case 'Pear':
                    shapeDisplayName = "Damla";
                    shapeImageUrl = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/Damla_vSon.png?v=1723103033';
                    break;
                case 'Radiant':
                    shapeDisplayName = "Radiant";
                    shapeImageUrl = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/Radiant_cizim_ikon2.png?v=1748851103';
                    break;
                case 'Emerald':
                    shapeDisplayName = "Emerald";
                    shapeImageUrl = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/Emerald_vSon.png?v=1723103033';
                    break;
                case 'Heart':
                    shapeDisplayName = "Kalp";
                    shapeImageUrl = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/Kalp_vSon.png?v=1723103033';
                    break;
                case 'Marquise':
                    shapeDisplayName = "Markiz";
                    shapeImageUrl = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/Markiz_vSon.png?v=1723103033';
                    break;
                case 'Cushion':
                    shapeDisplayName = "Cushion";
                    shapeImageUrl = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/Cushion_vSon.png?v=1723103033';
                    break;
                case 'Princess':
                    shapeDisplayName = "Prenses";
                    shapeImageUrl = 'https://cdn.shopify.com/s/files/1/0568/7676/1219/files/Prenses_vSon.png?v=1723103033';
                    break;
            }
            const cutDisplay = gradeDisplayMap[diamond.cut] || diamond.cut;
            const polishDisplay = gradeDisplayMap[diamond.polish] || diamond.polish;
            const symmetryDisplay = gradeDisplayMap[diamond.symmetry] || diamond.symmetry;
            const fluorIntensityDisplay = gradeDisplayMap[diamond.fluor_intensity] || diamond.fluor_intensity;
            const row = `<tr onclick='createViewProductDiamond(this)' data-shape='${shapeDisplayName}' data-size='${diamond.size}' data-certificate_url='${diamond.certificate_url}' data-color='${diamond.color}' data-clarity='${diamond.clarity}' data-cut='${cutDisplay}' data-symmetry='${symmetryDisplay}' data-polish='${polishDisplay}' data-depth_percent='${diamond.depth_percent}' data-table_percent='${diamond.table_percent}' data-meas_length='${diamond.meas_length}' data-meas_width='${diamond.meas_width}' data-meas_depth='${diamond.meas_depth}' data-fluor_color='${diamond.fluor_color}' data-fluor_intensity='${fluorIntensityDisplay}' data-has_cert_file='${diamond.has_cert_file}' data-lab='${diamond.lab}' data-price='${diamond.total_sales_price}' data-cert_num='${diamond.cert_num}' data-has_image_file='${diamond.has_image_file}' data-image_file_url='${diamond.image_file_url}' data-video_url='${diamond.video_url}'>
                <td>
                <img src="${shapeImageUrl}" alt="${shapeDisplay}" width="21" height="21">
                <span>${shapeDisplayName}</span>
                </td>
                <td>${new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(diamond.total_sales_price * dxCurrency)}</td>
                <td>${diamond.size}</td>
                <td>${diamond.color}</td>
                <td>${diamond.clarity}</td>
                <td>${cutDisplay}</td>
                <td>${polishDisplay}</td>
                <td>${symmetryDisplay}</td>
                <td>${fluorIntensityDisplay}</td>
                <td>${diamond.lab}</td>
                <td>${diamond.cert_num}</td>
                <td class="dxtable-last-column">
                    <p onclick='toggleFavorite(this, event)' class='fav-diamond-button' data-cert_num='${diamond.cert_num}'><svg style="stroke-width:3px" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M35.54 15.44 32 19l-3.54-3.53A11.67 11.67 0 0 0 12 31.94l3.54 3.54 8.25 8.25L32 52l8.25-8.25 8.25-8.25 3.5-3.56a11.67 11.67 0 0 0-16.5-16.5z"></path></g></svg></p>
                    <p class='add-to-cart' data-shape='${shapeDisplayName}' data-size='${diamond.size}' data-color='${diamond.color}' data-clarity='${diamond.clarity}' data-cut='${cutDisplay}' data-symmetry='${symmetryDisplay}' data-polish='${polishDisplay}' data-depth_percent='${diamond.depth_percent}' data-table_percent='${diamond.table_percent}' data-meas_length='${diamond.meas_length}' data-meas_width='${diamond.meas_width}' data-meas_depth='${diamond.meas_depth}' data-fluor_color='${diamond.fluor_color}' data-fluor_intensity='${fluorIntensityDisplay}' data-has_cert_file='${diamond.has_cert_file}' data-lab='${diamond.lab}' data-price='${diamond.total_sales_price}' data-cert_num='${diamond.cert_num}' data-has_image_file='${diamond.has_image_file}' data-image_file_url='${diamond.image_file_url}' data-video_url='${diamond.video_url}'><svg fill="#6d4e3b" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xml:space="preserve" stroke="#6d4e3b"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <g> <rect x="248.282" width="15.437" height="55.646"></rect> </g> </g> <g> <g> <rect x="301.818" y="37.505" transform="matrix(0.4198 -0.9076 0.9076 0.4198 150.2104 325.4243)" width="55.645" height="15.436"></rect> </g> </g> <g> <g> <rect x="352.888" y="94.013" transform="matrix(0.9051 -0.4251 0.4251 0.9051 -7.1327 171.4971)" width="55.644" height="15.437"></rect> </g> </g> <g> <g> <rect x="123.564" y="73.921" transform="matrix(0.4252 -0.9051 0.9051 0.4252 -16.6274 177.3064)" width="15.437" height="55.646"></rect> </g> </g> <g> <g> <rect x="174.632" y="17.401" transform="matrix(0.9076 -0.4198 0.4198 0.9076 -2.1385 80.7295)" width="15.436" height="55.645"></rect> </g> </g> <g> <g> <path d="M290.936,186.543v-6.118h1.686l35.049-49.114c0.269-0.375,0.487-0.77,0.682-1.175c0.557-1.074,0.877-2.292,0.877-3.583 v-3.216l-32.892-32.611h-80.676l-32.891,32.611v3.216c0,1.27,0.311,2.467,0.851,3.529c0.199,0.419,0.422,0.828,0.698,1.213 l35.059,49.13h1.686v6.118C147.03,202.608,91.399,268.625,91.399,347.399C91.399,438.16,165.24,512,256,512 S420.6,438.16,420.6,347.399C420.602,268.625,364.972,202.608,290.936,186.543z M288.649,159.42l-17.874-25.047h35.747 L288.649,159.42z M275.499,180.425v2.374h-38.997v-2.374H275.499z M238.344,164.987l17.657-24.743l17.657,24.743H238.344z M222.019,106.164h67.964l12.882,12.772h-93.726L222.019,106.164z M205.48,134.372h35.747l-17.874,25.047L205.48,134.372z M256.001,496.563c-82.249,0-149.163-66.915-149.163-149.163s66.915-149.163,149.163-149.163s149.163,66.915,149.163,149.163 S338.25,496.563,256.001,496.563z"></path> </g> </g> <g> <g> <path d="M256.001,221.877c-69.213,0-125.523,56.309-125.523,125.523s56.31,125.523,125.523,125.523 s125.523-56.309,125.523-125.523S325.214,221.877,256.001,221.877z M256.001,457.485c-60.701,0-110.086-49.384-110.086-110.086 s49.384-110.086,110.086-110.086s110.086,49.384,110.086,110.086C366.087,408.102,316.702,457.485,256.001,457.485z"></path> </g> </g> </g></svg></p>
                </td>
            </tr>`;
            tableBody.append(row);
        });

        updatePaginationButtons(page);
        favDiamondsCertNums = loadFavoritesFromCookie();
    }